export const AGENT_SKILL_BODY_MAX_CHARS = 20_000;
export const AGENT_SKILL_KICK_BODY_MAX_CHARS = 40_000;
export const AGENT_SKILL_ALWAYS_MAX_COUNT = 8;
export const AGENT_SKILL_ALWAYS_MAX_CHARS = 32_000;
export const AGENT_SKILL_TITLE_MAX_CHARS = 120;
export const AGENT_SKILL_DESCRIPTION_MAX_CHARS = 300;
export const AGENT_SKILL_KICK_DESCRIPTION_MAX_CHARS = 500;
export const AGENT_SKILL_CHAT_INSTRUCTION_MAX_CHARS = 2_000;

export const FIRM_SKILL_PREFIX = "firm/";

// Titles of the host prompt sections a pasted skill body may not pose as.
// Imported by the core body screen and by the backend prompt fragments.
export const HOST_PROMPT_SECTION_TITLES = [
    "RULES",
    "DATA RULE",
    "SKILL RULE",
    "FIRM SKILLS",
    "FIRM SKILL RULE",
    "SKILLS SELECTED FOR THIS TURN",
    "Always loaded",
    "Available on demand",
] as const;
